import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {FormBuilder, FormControl, Validators, FormGroup} from '@angular/forms';
import {HttpHeaders} from '@angular/common/http';
import {Router} from '@angular/router';

import {Store} from '@ngrx/store';
import {AuthService, ConfigService, StorageService} from '@cosbeni/auth';
import {FormHelperService} from '../services/form-helper.service';
import {ToasterConfig, ToasterService} from 'angular2-toaster';

import {LotasConfig} from '../config/lotas.config';
import {DataService} from '@cosbeni/database';
import {appVersion} from '../../environments/version';

declare let jQuery: any;

@Component({
    selector: 'app-dashboard',
    styleUrls: ['../../scss/vendors/toastr/toastr.scss','../../scss/style.scss','login.component.css'],
    templateUrl: 'login.component.html',
    encapsulation: ViewEncapsulation.None
})
export class LoginComponent implements OnInit {
    appVersion = appVersion;
    account: any = {username: '', password: '', url: LotasConfig.DATABASE_URL, database: {name: LotasConfig.DATABASE}};
    form: FormGroup;
    toasterconfig: ToasterConfig =
        new ToasterConfig({
            tapToDismiss: true,
            timeout: 5000000,
            toastContainerId: 0
        });

    constructor(public store: Store<any>, public router: Router, public formHelper: FormHelperService, public formBuilder: FormBuilder, public auth: AuthService, public dataService: DataService, public config: ConfigService, public storage: StorageService, public toasterService: ToasterService) {
    }

    ngOnInit() {
        this.form = this.formBuilder.group({
            username: new FormControl('', [Validators.required, Validators.minLength(3)]),
            // 移行後にパスワードが2文字のユーザが存在するため最小長制限は設けない (空文字のみ不可)。
            password: new FormControl('', [Validators.required]),
        });
    }

    login(value: any) {
        this.doLogin(value.username, value.password);
    }

    private doLogin(username: string, password: string): void {
        const data = jQuery.param({grant_type: 'password', username: username, password: password});
        this.storage.set(this.account.database.name + '_url', this.account.url, '');
        this.storage.set('database', this.account.database.name, '');
        this.config.setTokenPrefix(this.account.database.name);
        this.auth.login(data, this.account.url + '/token/' + this.account.database.name, {headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')})
            .subscribe(response => {
                    let sql = 'BEGIN\n';
                    sql = sql + 'let user = SELECT FROM OUser WHERE name = \'' + username + '\'\n';
                    sql = sql + 'INSERT INTO LOTAS_LoginHistory SET user = $user, time = sysdate()\n';
                    sql = sql + 'COMMIT RETRY 100\n';
                    this.dataService.batch({sql: sql}, LotasConfig.SERVER_URL).subscribe((response: any) => {
                        this.router.navigate(['legacy/user/home'], {});
                    }, (error: any) => {
                        this.toasterService.pop('error', '保存', 'ログイン履歴保存に失敗しました。');
                    });
                },
                err => {
                    this.toasterService.pop('error', 'ログインに失敗しました', 'ユーザ名、パスワードを再度ご確認下さい。');
                },
            );
    }
}
